import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Formate un montant venant du serveur (string DECIMAL) sans jamais passer par un float. */
export function formatMoney(value: string | null | undefined): string {
  if (value == null) return '—';
  return new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD' }).format(Number(value));
}

/** 18.8 → « 18,8 % » (format québécois). */
export function formatPct(value: number | null | undefined): string {
  if (value == null) return '—';
  return `${value.toLocaleString('fr-CA', { maximumFractionDigits: 1 })} %`;
}
